import React, { useEffect } from "react";
import Loadable from "@loadable/component";
import { fontsName } from "../assets/fonts/fontsName";
import ClearIcon from "@material-ui/icons/Clear";
import { Modal, Backdrop } from "@material-ui/core";
const OwlCarousel = Loadable(() => import("react-owl-carousel3"));

const optionsTwo = {
  loop: true,
  nav: true,
  dots: false,
  autoplayHoverPause: false,
  autoplay: true,
  margin: 30,
  navText: [
    "<i class='flaticon-left-1'></i>",
    "<i class='flaticon-right-1'></i>",
  ],
  responsive: {
    0: {
      items: 1,
    },
    768: {
      items: 1,
    },
    992: {
      items: 1,
    },
  },
};

const GalleryModal = ({ open, onClose, imagesInfo }) => {
  const [display, setDisplay] = React.useState(false);

  React.useEffect(() => {
    setDisplay(true);
  }, []);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      style={{ overflow: "scroll", paddingLeft: "30px", paddingRight: "30px" }}
    >
      <>
        <div style={{ textAlign: "right" }}>
          <ClearIcon
            style={{
              marginTop: "20px",
              marginRight: "20px",
              color: "#fff",
              cursor: "pointer",
              fontSize: "35px",
            }}
            onClick={onClose}
          />
        </div>
        <section className="section-images">
          {display ? (
            <OwlCarousel
              className="testimonials-slides  owl-carousel owl-theme"
              {...optionsTwo}
            >
              {imagesInfo &&
              imagesInfo.pictureLinks &&
              imagesInfo.pictureLinks.length > 0
                ? imagesInfo.pictureLinks.map((item, index) => (
                    <img
                      key={index}
                      src={item}
                      className="middle gallery-image"
                      alt="gallery"
                      // style={{ height: "350px", width: "100%" }}
                    />
                  ))
                : ""}

              {/* <img
                  src={Partner5}
                  className="middle gallery-image"
                  alt="Partner"
                />
                <img
                  src={Partner6}
                  className="middle gallery-image"
                  alt="Partner"
                />

                <img
                  src={Partner4}
                  className="middle gallery-image"
                  alt="Partner"
                />
                <img
                  src={Partner5}
                  className="middle gallery-image"
                  alt="Partner"
                />
                <img
                  src={Partner6}
                  className="middle gallery-image"
                  alt="Partner"
                />
                <img
                  src={Partner4}
                  className="middle gallery-image"
                  alt="Partner"
                /> */}
            </OwlCarousel>
          ) : (
            ""
          )}
        </section>
      </>
    </Modal>
  );
};

export default GalleryModal;
